import Instruction from 'app/src/engine/instructions/Instruction';
import RotateInstructionSegment, {
	RotateInstructionSegmentType,
} from 'app/src/engine/instructions/RotateInstructionSegment';

export enum RotateInstructionType {
	TurnLeft,
	TurnRight,
	UTurn,
}

export default class RotateInstruction extends Instruction {
	get basePriority(): number {
		switch (this._type) {
			case RotateInstructionType.TurnLeft:
			case RotateInstructionType.TurnRight:
				return 100;

			case RotateInstructionType.UTurn:
				return 150;
		}

		throw new Error('Invalid RotateInstructionType');
	}

	private _type: RotateInstructionType;
	get type(): RotateInstructionType {
		return this._type;
	}

	constructor(type: RotateInstructionType) {
		super();

		this._type = type;
		this.reset();
	}

	// Interactions need to be reset after being used.
	public reset(): void {
		// Create segments.
		switch (this._type) {
			case RotateInstructionType.TurnLeft:
				this._remainingSegments = [
					new RotateInstructionSegment(RotateInstructionSegmentType.TurnLeft),
				];
				break;

			case RotateInstructionType.TurnRight:
				this._remainingSegments = [
					new RotateInstructionSegment(RotateInstructionSegmentType.TurnRight),
				];
				break;

			case RotateInstructionType.UTurn:
				this._remainingSegments = [
					new RotateInstructionSegment(RotateInstructionSegmentType.TurnLeft),
					new RotateInstructionSegment(RotateInstructionSegmentType.TurnLeft),
				];
				break;
		}
	}
}
